import React, { useEffect, useRef } from 'react';

const CollapsibleContainer = ({ children, open }) => {
    const containerRef = useRef(null);

    useEffect(() => {
        if (containerRef.current) {
            containerRef.current.style.height = open ? `${containerRef.current.scrollHeight}px` : '0px';
        }
    }, [open]);

    return (
        <div
            ref={containerRef}
            style={{
                height: '0px', // Initial height is 0
                transition: 'height 0.25s ease-in-out',
                overflow: 'hidden',
            }}
        >
            {children}
        </div>
    );
};

export default CollapsibleContainer;
